import React, { useEffect, useState } from 'react';
import syncIcon from '../../../images/icon-synchronize.svg';
import syncIconGray from '../../../images/icon-synchronize-gray.svg';
import styles from './SyncButton.module.css';

interface SyncButtonProps {
    guestCardId: string | null;
    syncGuestCardLoading: boolean;
}

export const SyncButton = ({ guestCardId, syncGuestCardLoading }: SyncButtonProps) => {
    const [isSyncClicked, setIsSyncClicked] = useState(false);

    useEffect(() => {
        if (!syncGuestCardLoading) {
            setIsSyncClicked(false);
        }
    }, [syncGuestCardLoading]);

    return (
        <img
            src={syncIcon}
            alt="sync-icon"
            width={18}
            height={18}
            className={isSyncClicked ? styles.rotate : styles.editIcon}
            onClick={() => {
                setIsSyncClicked(true);
            }}
        />
    );
};
